<template lang="pug">
#gestao-certificacao
    BaseHeader#nova-analise-certificacao(
        titulo='Certificações',
        icon='mdi mdi-file-plus',
        btnTexto='Nova análise',
        :exibeBotao='true',
        @btnHeaderClicado='novaAnalise'
    )

    .view-container.margen-bottom-pages
        .bloco-infor-dados
            .item-container
                SkeletonBlocoInformacao(:carregando='carregandoTotalizadores')
                    BlocoInformacao.bloco-informacao(
                        titulo='Territórios analisados',
                        :numero='totalizadores.territoriosAnalisados',
                        :class='[tagsFiltro.includes("Territórios analisados") ? "bloco-infor-dados-ativo" : ""]'
                    )

            .item-container(@click='setFiltro("AREA", 1)')
                SkeletonBlocoInformacao(:carregando='carregandoTotalizadores')
                    BlocoInformacao.bloco-informacao(
                        titulo='Área de Plantio Elegível (ha)',
                        sigla='(ha)',
                        :numero='totalizadores.areaPlantioCertificavel && formatNumber(totalizadores.areaPlantioCertificavel)',
                        :class='[tagsFiltro.includes("Área plantio elegível") ? "bloco-infor-dados-ativo" : ""]'
                    )

            .item-container(@click='setFiltro("2BSvs", 2)')
                SkeletonBlocoInformacao(:carregando='carregandoTotalizadores')
                    BlocoInformacao.bloco-informacao(
                        titulo='Territórios elegíveis 2BSvs',
                        :numero='totalizadores.territorios2BSvs > 0 ? totalizadores.territorios2BSvs : 0',
                        :class='[tagsFiltro.includes("2BSvs: Elegível") ? "bloco-infor-dados-ativo" : ""]'
                    )
        .bloco-infor-dados
            .item-container(@click='setFiltro("RTRS", 3)')
                SkeletonBlocoInformacao(:carregando='carregandoTotalizadores')
                    BlocoInformacao.bloco-informacao(
                        titulo='Territórios elegíveis RTRS',
                        :numero='totalizadores.territoriosRTRS > 0 ? totalizadores.territoriosRTRS : 0',
                        :class='[tagsFiltro.includes("RTRS: Elegível") ? "bloco-infor-dados-ativo" : ""]'
                    )

            .item-container(@click='setFiltro("Proterra", 4)')
                SkeletonBlocoInformacao(:carregando='carregandoTotalizadores')
                    BlocoInformacao.bloco-informacao(
                        titulo='Territórios elegíveis Proterra',
                        :numero='totalizadores.territoriosProTerra > 0 ? totalizadores.territoriosProTerra : 0',
                        :class='[tagsFiltro.includes("Proterra: Elegível") ? "bloco-infor-dados-ativo" : ""]'
                    )

            .item-container(@click='setFiltro("EPA", 5)')
                SkeletonBlocoInformacao(:carregando='carregandoTotalizadores')
                    BlocoInformacao.bloco-informacao(
                        titulo='Territórios elegíveis EPA',
                        :numero='totalizadores.territoriosEPA > 0 ? totalizadores.territoriosEPA : 0',
                        :class='[tagsFiltro.includes("EPA: Elegível") ? "bloco-infor-dados-ativo" : ""]'
                    )

            .item-container(@click='setFiltro("EUDR", 6)')
                SkeletonBlocoInformacao(:carregando='carregandoTotalizadores')
                    BlocoInformacao.bloco-informacao(
                        titulo='Territórios elegíveis EUDR',
                        :numero='totalizadores.territoriosEUDR > 0 ? totalizadores.territoriosEUDR : 0',
                        :class='[tagsFiltro.includes("EUDR: Elegível") ? "bloco-infor-dados-ativo" : ""]'
                    )

        .bloco-pesquisa-filtros
            BlocoPesquisaFiltros(
                @emitFiltros='adicionarFiltros',
                @emitFiltroTotalizador='adicionarFiltros',
                ref='aplicarFiltroTotalizador'
            )

        .bloco-novos-contratos-tabela
            TabelaGestaoCertificacao(
                :tabelaData='certificacoesTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela',
                @atualizarTabela='buscarCertificacoes',
                @handleModalGerarAnalise='handleModalGerarAnalise',
                @handleModalSolicitarLaudo='handleModalSolicitarLaudo',
                @handleModalAcompanharSolicitacaoLaudo='handleModalAcompanharSolicitacaoLaudo',
                @handleDownloadLaudo='handleDownloadLaudo',
                :btnRecarregar='true'
            )

        ModalGerarAnalise(
            v-if='rowInfo',
            :show.sync='showModalGerarAnalise',
            :rowInfo='rowInfo',
            :checked='checkedValues',
            @atualizarTabela='buscarCertificacoes'
        )

        ModalSolicitarLaudo(
            v-if='rowInfo',
            :show.sync='showModalSolicitarLaudo',
            :rowInfo='rowInfo',
            @atualizarTabela='buscarCertificacoes'
        )

        ModalAcompanharSolicitacaoLaudo(
            v-if='rowInfo',
            :show.sync='showModalAcompanharSolicitacaoLaudo',
            :rowInfo='rowInfo',
            @atualizarTabela='buscarCertificacoes'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';

import BlocoInformacao from '@/components/certificacao/BlocoInformacaoCertificacao.vue';
import ModalGerarAnalise from '@/components/certificacao/ModalGerarAnalise.vue';
import ModalSolicitarLaudo from '@/components/certificacao/ModalSolicitarLaudo.vue';
import ModalAcompanharSolicitacaoLaudo from '@/components/certificacao/ModalAcompanharSolicitacaoLaudo.vue';
import SkeletonBlocoInformacao from '@/components/certificacao/BlocoSkeletonInformacaoCertificacao.vue';
import BlocoPesquisaFiltros from '@/components/certificacao/PesquisaFiltroCertificacao.vue';
import TabelaGestaoCertificacao from '@/components/certificacao/TabelaGestaoCertificacao.vue';
import InserirCertificacao from '@/views/certificacao/InserirCertificacao.vue';
import CertificacaoService from '@/services/CertificacaoService.js';

import formatters from '@/utils/formatters';

import { mapActions } from 'vuex';

export default {
    name: 'GestaoCertificacao',
    components: {
        BaseHeader,
        BlocoInformacao,
        SkeletonBlocoInformacao,
        BlocoPesquisaFiltros,
        TabelaGestaoCertificacao,
        InserirCertificacao,
        ModalGerarAnalise,
        ModalSolicitarLaudo,
        ModalAcompanharSolicitacaoLaudo
    },
    data() {
        return {
            numero: [750, 12.124, 634, 234, 235, 532],
            carregandoTabela: false,
            carregandoTotalizadores: false,
            showModalGerarAnalise: false,
            showModalSolicitarLaudo: false,
            showModalAcompanharSolicitacaoLaudo: false,
            rowInfo: null,
            checkedValues: [],
            params: {
                page: 0,
                size: 10,
                sort: 'dataCadastro',
                por: 'desc'
            },
            paginacao: {},
            certificacoesTabela: [],
            totalizadores: {
                areaPlantioCertificavel: 0,
                territoriosAnalisados: '',
                territorios2BSvs: '',
                territoriosEPA: '',
                territoriosProTerra: '',
                territoriosRTRS: '',
                territoriosEUDR: ''
            },
            filtro: {
                pesquisaFiltro: '',
                estadoId: [],
                territoriosAnalisados: false,
                areaPlantadaElegivel: false
            },
            codigosTotalizadores: [
                {
                    codigoAtivo: false,
                    tag: 'Territórios analisados'
                },
                {
                    codigoAtivo: false,
                    tag: 'Área plantio elegível'
                },
                { codigoAtivo: false, tag: '2BSvs: Elegível' },
                { codigoAtivo: false, tag: 'RTRS: Elegível' },
                { codigoAtivo: false, tag: 'Proterra: Elegível' },
                { codigoAtivo: false, tag: 'EPA: Elegível' }
            ],
            tagsFiltro: []
        };
    },
    mounted() {
        this.buscarCertificacoes();
    },
    methods: {
        ...mapActions('analyzeDeforestationStore', [
            'detail',
            'downloadReport'
        ]),

        novaAnalise() {
            this.$router.push({ name: 'CadastrarCertificacao' });
        },

        handleModalGerarAnalise(rowInfo) {
            if (rowInfo) {
                this.rowInfo = rowInfo;
                if (this.rowInfo.certificacoes) {
                    this.checkedValues = this.rowInfo.certificacoes
                        .filter(
                            cert => cert.status != null && cert.status === true
                        )
                        .map(item => item.status);
                }
                this.showModalGerarAnalise = !this.showModalGerarAnalise;
            }
        },

        handleModalSolicitarLaudo(rowInfo) {
            if (rowInfo) {
                this.rowInfo = rowInfo;
                this.showModalSolicitarLaudo = !this.showModalSolicitarLaudo;
            }
        },

        handleModalAcompanharSolicitacaoLaudo(rowInfo) {
            if (rowInfo) {
                this.rowInfo = rowInfo;
                this.showModalAcompanharSolicitacaoLaudo =
                    !this.showModalAcompanharSolicitacaoLaudo;
            }
        },

        async handleDownloadLaudo(rowInfo) {
            try {
                const file = await this.downloadReport(rowInfo.idLaudo);
                const url = URL.createObjectURL(file.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = `laudo-${rowInfo.idLaudo}.pdf`;
                document.body.appendChild(link); // Append to body to ensure visibility in certain browsers
                link.click();
                document.body.removeChild(link); // Clean up
                this.$notify.success({
                    message: 'Laudo baixado com sucesso'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao baixar o laudo do CAR'
                });
            }
        },

        async buscarCertificacoes() {
            this.carregandoTabela = true;
            this.carregandoTotalizadores = true;

            try {
                const { data } =
                    await CertificacaoService.buscarCertificacoesV2(
                        this.filtro,
                        this.params
                    );

                this.certificacoesTabela = data.itens;

                this.paginacao = data.paginacao;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os territórios'
                });
            }
            this.carregandoTabela = false;

            this.buscarTotalizadoresCertificacoes();
        },

        async buscarTotalizadoresCertificacoes() {
            try {
                const { data } =
                    await CertificacaoService.buscarTotalizadoresCertificacao();
                const itens = data.itens;

                itens.map(territoriosElegiveis => {
                    switch (territoriosElegiveis.tipo) {
                        case 'EPA':
                            this.totalizadores.territoriosEPA =
                                territoriosElegiveis.quantidade;
                            break;

                        case 'RTRS':
                            this.totalizadores.territoriosRTRS =
                                territoriosElegiveis.quantidade;
                            break;

                        case '2BSvs':
                            this.totalizadores.territorios2BSvs =
                                territoriosElegiveis.quantidade;
                            break;

                        case 'Proterra':
                            this.totalizadores.territoriosProTerra =
                                territoriosElegiveis.quantidade;
                            break;

                        case 'EUDR':
                            this.totalizadores.territoriosEUDR =
                                    territoriosElegiveis.quantidade;
                            break;

                        default:
                            break;
                    }
                });

                this.totalizadores.areaPlantioCertificavel =
                    data.areaPlantioCertificavel;
                this.totalizadores.territoriosAnalisados =
                    data.territoriosAnalisados;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os Totalizadores'
                });
            }
            this.carregandoTotalizadores = false;
        },

        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        },

        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.params.page = novaPagina;
            this.buscarCertificacoes();
        },
        ordenarTabela(column) {
            if (column.prop === 'nomeTerritorio') {
                this.params.sort = 'geoRel.nomeTerritorio';
            } else {
                this.params.sort = column.prop;
            }
            if (column.prop === 'areaPlantadaHa') {
                this.params.sort = 'geoRel.areaPlantadaHa';
            }

            if (column.order === 'ascending') {
                this.params.por = 'asc';
            } else if (column.order === 'descending') {
                this.params.por = 'desc';
            }
            this.buscarCertificacoes();
        },
        adicionarFiltros(filtro, tags) {
            if (tags && tags.length) {
                this.tagsFiltro = [];

                tags.forEach(item => {
                    if (typeof item === 'string') {
                        if (!this.tagsFiltro.includes(item)) {
                            this.tagsFiltro.push(item);
                        }
                    } else if (typeof item === 'object' && item.nome) {
                        if (!this.tagsFiltro.includes(item.nome)) {
                            this.tagsFiltro.push(item.nome);
                        }
                    }
                });
            } else {
                this.tagsFiltro = [];
            }

            // Verifica quais tags dos totalizadores estão ativas e
            // indica se o totalizador está ou não selecionado.
            this.codigosTotalizadores.forEach(totalizador => {
                const tagPresente = this.tagsFiltro.includes(totalizador.tag);
                if (!tagPresente) {
                    totalizador.codigoAtivo = false;
                }
            });
            if (filtro.certificacaoTipoStatus) {
                if (Object.keys(filtro.certificacaoTipoStatus).length > 0) {
                    this.certificacoesComoObjeto(filtro.certificacaoTipoStatus);
                } else {
                    this.filtro.certificacaoTipoStatus = {};
                    let codigosTotalizadores = [
                        {
                            codigoAtivo:
                                this.codigosTotalizadores[0].codigoAtivo,
                            tag: 'Territórios analisados'
                        },
                        {
                            codigoAtivo:
                                this.codigosTotalizadores[1].codigoAtivo,
                            tag: 'Área plantio elegível'
                        },
                        { codigoAtivo: false, tag: '2BSvs: Elegível' },
                        { codigoAtivo: false, tag: 'RTRS: Elegível' },
                        {
                            codigoAtivo: false,
                            tag: 'Proterra: Elegível'
                        },
                        { codigoAtivo: false, tag: 'EPA: Elegível' }
                    ];

                    this.codigosTotalizadores = codigosTotalizadores;
                }
            }

            if (tags.includes('Territórios analisados')) {
                this.filtro.territoriosAnalisados = true;
            } else {
                this.filtro.territoriosAnalisados = false;
            }

            if (tags.includes('Área plantio elegível')) {
                this.filtro.areaPlantadaElegivel = true;
            } else {
                this.filtro.areaPlantadaElegivel = false;
            }

            this.filtro.pesquisaFiltro = filtro.pesquisa || '';
            this.filtro.estadoId = filtro.estadoSelecionado || '';
            this.params.page = 0;

            this.buscarCertificacoes();
        },

        setFiltro(dado, indice) {
            this.codigosTotalizadores[indice].codigoAtivo =
                !this.codigosTotalizadores[indice].codigoAtivo;

            if (this.codigosTotalizadores[indice].codigoAtivo) {
                this.$refs.aplicarFiltroTotalizador.inserirFiltroTotalizador(
                    dado
                );
            } else {
                this.$refs.aplicarFiltroTotalizador.removerFiltro(dado);
            }
        },

        certificacoesComoObjeto(filtroCertificacaoTipoStatus) {
            let certificacoesComoObjeto = {};

            if (filtroCertificacaoTipoStatus) {
                Object.keys(filtroCertificacaoTipoStatus).forEach(function (
                    key
                ) {
                    certificacoesComoObjeto[key] =
                        filtroCertificacaoTipoStatus[key];
                });
            }
            this.filtro.certificacaoTipoStatus = certificacoesComoObjeto;
        }
    }
};
</script>

<style lang="scss">
#gestao-certificacao {
    .bloco-infor-dados {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(25%, 1fr));
        justify-content: space-between;
        gap: 10px;
        width: 100%;
        flex-wrap: wrap;

        #certificacao-bloco-informacoes {
            cursor: pointer;
        }
    }

    .bloco-infor-dados,
    .bloco-novos-contratos-tabela {
        margin-top: 20px;
    }

    .secao-listagem-filtro-sub-empresa {
        display: flex;
        margin-top: 25px;
        justify-content: space-between;

        .el-checkbox__label,
        .titulo-listagem h3 {
            font-weight: bold;
        }
    }

    .bloco-informacao {
        cursor: pointer;
    }

    #certificacao-bloco-informacao {
        border: 1px solid #e1e1e1;

        &.bloco-infor-dados-ativo {
            border-color: var(--primary) !important;
        }
    }
}

@media only screen and (max-width: 1200px) {
    .bloco-infor-dados > div {
        width: 32%;
    }
}
</style>
